import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'cx_foundations-answer_page-view';
/**
 * Event that tracks when user views the &quot;Answer&quot; page
 */
export function trackCxFoundationsAnswerPageView(Retailerbrand_token, issueTree2) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { Retailerbrand_token, issueTree2 },
    });
}
